import { createFileRoute } from '@tanstack/react-router';
import { DisputeDetailPage } from '../../features/disputes';

export const Route = createFileRoute('/portal/disputes/$id')({
  component: function DisputeRoute() {
    const { id } = Route.useParams();
    return <DisputeDetailPage id={id} />;
  },
});
